import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffects3dSkin = {
  ...textEffectsSharedSkin,
  'text-stroke': {
    type: 'NUMBER',
    defaultValue: '4',
  },
  'shadow-angle': {
    type: 'CSSString',
    defaultValue: '90deg',
  },
  'shadow-blur': {
    type: 'NUMBER',
    defaultValue: '0',
  },
  'shadow-distance': {
    type: 'NUMBER',
    defaultValue: '4.1',
  },
  'shadow2-angle': {
    type: 'CSSString',
    defaultValue: '90deg',
  },
  'shadow2-blur': {
    type: 'NUMBER',
    defaultValue: '8',
  },
  'shadow2-distance': {
    type: 'NUMBER',
    defaultValue: '4',
  },
  'shadow3-angle': {
    type: 'CSSString',
    defaultValue: '90deg',
  },
  'shadow3-blur': {
    type: 'NUMBER',
    defaultValue: '44',
  },
  'shadow3-distance': {
    type: 'NUMBER',
    defaultValue: '12',
  },
  'text-effect-color-1': {
    type: 'COLOR',
  },
  'text-effect-color-2': {
    type: 'COLOR',
  },
  'text-effect-color-3': {
    type: 'COLOR',
  },
  'text-effect-color-4': {
    type: 'COLOR',
  },
  'text-effect-color-5': {
    type: 'COLOR',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffects3dSkinDefinitionMap: Record<string, SiteAssetsSkinParams> = {
  'wixui.skins.TextEffects3d': TextEffects3dSkin,
};

export default generateSkinDefaults(TextEffects3dSkinDefinitionMap);
